module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticStyle: {
      "padding": ".26rem 0",
      "font-size": ".32rem",
      "font-weight": "bold"
    }
  }, [_vm._v("券包可用商家")]), _vm._v(" "), _c('div', {
    staticClass: "main no-foot"
  }, [(_vm.showPage) ? _c('div', [(_vm.bannerUrl) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.bannerUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopList.length > 0) ? _c('div', {
    staticClass: "goods-list shop"
  }, [_c('ul', {
    staticClass: "goods"
  }, _vm._l((_vm.shopList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    }), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v(_vm._s(item.mark))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "threshold"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.new_delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])]) : _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()]), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2) {
      return _c('span', {
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-51c76fa6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/CouponPackageShopList.vue
// module id = 439
// module chunks = 7